<template>
  <div>
    <img
        :src="require(`.././../../assets/images/upgrade-now@2x.png`)"
        :srcset="`${require(`../../../assets/images/upgrade-now@1x.png`)} 1x, ${require(`../../../assets/images/upgrade-now@2x.png`)} 2x, ${require(`../../../assets/images/upgrade-now@3x.png`)} 3x, ${require(`../../../assets/images/upgrade-now@4x.png`)} 4x`"
    />

    <div class="modal-body">
      <h2>{{ translate('Unlock Ultimate Features') }}</h2>
      <p>{{ translate('Dive into a world of limitless creativity and make your mark as an elite image creator.') }}</p>
      <p v-html="getUpgradeText">
      </p>
      <p>{{ translate('Your artistic journey awaits!') }}</p>
    </div>
  </div>
</template>
<script>
import store from '../../../mixins/store.mixin';
import user from "../../../mixins/user.mixin";

export default {
  name: 'UnlockUltimateFeatures',
  props: {},
  components: {},
  mixins: [store, user],
  data() {
    return {};
  },
  methods: {},
  computed: {
    getUpgradeText() {
      return this.translate('<strong>Upgrade to our Pro subscription</strong> today and unlock the true potential of AI Image Creator Studio.');
    }
  },
};
</script>
